<template>
  <div id="selectMansion">
    <div class="mansionLabel" v-text="$t('proprietor.selectMansionModal.chooseMansion')"></div>
    <div class="selectMansionDiv">
      <div class="mansionImgDiv">
        <div class="contentDiv"  v-for="(mansion,inxdex) in selectMansionList">
          <div class="imgDiv">
            <img v-if="mansion.fileId != '0'" :src="getImageUrl(mansion)"/>
            <img v-else src="../../../../assets/defulat/mansion.png"/>
          </div>
          <div class="nameDiv">
            <a-tooltip placement="top">
              <template slot="title">
                <span v-text="mansion.name"></span>
              </template>
              <div class="mansionName" v-text="mansion.name">
              </div>
            </a-tooltip>
            <div class="deleteDiv" @click="deleteMansion(mansion)"><pt-icon type="icon-quxiao"></pt-icon></div>
          </div>
        </div>
      </div>
    </div>
    <div class="searchDiv">
      <div>
        <pt-search v-model="queryVO.queryText" :placeholder="$t('proprietor.selectMansionModal.searchText')" @searchEvent="searchEvent"></pt-search>
      </div>
      <div class="selectLetterDiv" style="margin-bottom: 15px;">
        <pt-select-latter v-model="queryVO.nameKey"></pt-select-latter>
      </div>
      <a-spin :spinning="loading">
        <el-table
          @row-click="rowClick"
          ref="selectMansionTable"
          :data="tableData"
          :show-header="true"
          row-key="id"
          @select="handleSelectionChange"
          @select-all="handleSelectionChangeAll"
          @sort-change="handleSortChange"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55">
          </el-table-column>
          <el-table-column
            align="left"
            prop="name"
            :label="$t('mansion.tableHeader.mansionName')"
            min-width="250">
          </el-table-column>

          <el-table-column
              align="left"
              prop="citys"
              :label="$t('mansion.tableHeader.citys')"
              min-width="100">
            <template slot-scope="scope">
              <span>{{scope.row.citys.toUpperCase()}}</span>
            </template>
          </el-table-column>

          <!-- Option完整度 -->
          <el-table-column
            align="center"
            prop="optionComplete"
            sortable="custom"
            show-overflow-tooltip
            min-width="120"
            :label="$t('mansion.tableHeader.option')">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;justify-content:center;">
                {{scope.row.optionComplete+"%"}}
              </div>
            </template>
          </el-table-column>

          <!-- Option完整度 -->
          <el-table-column
            align="center"
            prop="fabulous"
            sortable="custom"
            show-overflow-tooltip
            min-width="100"
            :label="$t('mansion.options.fabulous')">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;justify-content:center;">
                {{scope.row.fabulous}}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-pagination"  v-show="pagination.total > 0">
          <a-pagination size="small" @change="handleTableChange"  :hideOnSinglePage="true" :total="pagination.total" :pageSize="pagination.pageSize"  :current="pagination.current" :showTotal="pagination.showTotal" />
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
import {selectListByQuery} from '@/api/database/mansion'
import PtSelectLatter from "../../../../components/Latter/selectLatter";
import PtIcon from "../../../../components/Icon/index";
export default {
  components: {
    PtIcon,
    PtSelectLatter

  },
  name: 'selectMansion',
  props:{
    countNum:{
      default: 0,
      type:Number,
    },
    all:{
      type:Boolean,
      default:false
    },
    companyId:{
      default:null,
      type:String,
    },
    mansionList:{
      type: [Object, Array],
    },
  },
  data () {
    return {
      queryVO:{
        companyId:null,
        queryText:'',
        nameKey:null,
      },
      tableData:[],
      pageInfo:{
        current: 1,
      },
      pagination: {
        pageSize: 10,
        current: 1,
        total: 1,
        hideOnSinglePage:true,
        showTotal:(total)=>{
          return `共${total}条`
        }
      },
      loading:false,
      mansionIds:[],//如果是代理协议选择项目筛选出业主管理项目值
      selectMansionList:[],//选中的楼宇
      selectMansionIds:[],//选中的id
    }
  },
  watch: {
    'queryVO.nameKey'(){
      this.searchEvent();
    },
    companyId(val){
      this.queryVO.companyId = val;
    },
  },
  computed: {},
  mounted() {
    this.queryVO.companyId = this.companyId;
    this.init();
    this.queryList();
  },
  methods: {
    // 排序方法
    handleSortChange({ prop, order }) {
      this.pageInfo.current = 1;

      this.queryVO.sortField = prop;
      this.queryVO.sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : '';

      this.queryList();
    },
    rowClick(row){
      let flag = false;
      this.selectMansionList.forEach((mansion,index)=>{
        if (row.id == mansion.id) {
          let mansionIndex = this.selectMansionIds.indexOf(mansion.id);
          this.selectMansionIds.splice(mansionIndex, 1)
          this.selectMansionList.splice(index, 1)
          this.$refs.selectMansionTable.toggleRowSelection(row, false);
          flag = true;
        }
      })

      if(!flag){
        if( this.countNum != 0 &&  this.selectMansionIds.length >= this.countNum ){
          this.$refs.selectMansionTable.toggleRowSelection(row, false);
          this.$message.warning('最多只能选择三个大厦')
        }else{
          this.selectMansionIds.push(row.id)
          this.selectMansionList.push(row);
          this.$refs.selectMansionTable.toggleRowSelection(row, true);
        }
      }


    },
    deleteMansion(mansion){
      let index = this.selectMansionIds.indexOf(mansion.id);
      let mansionIndex = -1;
      for(var i = 0;i < this.selectMansionList.length;i++){
        if(this.selectMansionList[i].id == mansion.id){
          mansionIndex = i;
          break;
        }else{
          mansionIndex = -1;
        }
      }
      this.selectMansionIds.splice(index, 1);
      this.selectMansionList.splice(mansionIndex, 1);
      this.tableData.forEach(row => {
        if (row.id == mansion.id) {
          this.$refs.selectMansionTable.toggleRowSelection(row, false);
        }
      })
    },
    getImageUrl(mansion){
      let url = this.$util.getFileUrl(mansion.fileId);
      return url;
    },
    handleSelectionChange(selection, row){
      console.log("选择改变",selection,row);

      let index = this.selectMansionIds.indexOf(row.id)
      let mansionIndex = -1;
      for(var i = 0;i < this.selectMansionList.length;i++){
        if(this.selectMansionList[i].id == row.id){
          mansionIndex = i;
          break;
        }else{
          mansionIndex = -1;
        }
      }
      if (index != -1) {
        //删除
        this.selectMansionIds.splice(index, 1)
        if(!selection){
          this.$refs.selectMansionTable.toggleRowSelection(row, false);
        }
      } else {
        if(this.countNum !=0 && this.selectMansionList.length >= this.countNum ){
          this.$refs.selectMansionTable.toggleRowSelection(row, false);
          this.$message.warning('最多只能选择'+this.countNum+'个大厦')
          return false
        }else{
          //添加
          this.selectMansionIds.push(row.id)
          if(!selection){
            this.$refs.selectMansionTable.toggleRowSelection(row, true);
          }
        }
      }
      this.selectMansionList= selection;
    },
    handleSelectionChangeAll(selection){
      console.log("选择改变",selection);
      if(this.countNum !=0 && selection.length >= this.countNum ){
        this.$message.warning('最多只能选择三个大厦')
        this.$nextTick(()=>{
          this.$refs.selectMansionTable.clearSelection();
          this.selectMansionList.forEach(data=>{
            this.$refs.selectMansionTable.toggleRowSelection(data, true);
          })
        })
        return false
      }else{
        this.selectMansionList= selection;
      }
    },
    toggleSelection(){
      this.$nextTick(() => {
        if (this.selectMansionIds) {
          this.selectMansionIds.forEach(data => {
            this.tableData.forEach(row => {
              if (row.id == data) {
                this.$refs.selectMansionTable.toggleRowSelection(row, true);
              }
            })
          });
        }
      })
    },
    init () {
      if(this.mansionList && this.mansionList.length > 0){
        this.selectMansionList = [];
        this.selectMansionIds = [];
        this.mansionList.forEach(item=>{
          this.selectMansionList.push(item);
          this.selectMansionIds.push(item.id);
        })
      }else{
        this.selectMansionList = [];
        this.selectMansionIds = [];
      }

    },
    searchEvent(){
      this.pageInfo.current = 1;
      this.queryList();
    },
    handleTableChange(page,pageSize){
      this.pageInfo.current = page
      this.queryList();
    },
    queryList(){
      this.loading = true
      let this_ = this
      selectListByQuery({
        size:this_.pagination.pageSize,
        current: this_.pageInfo.current,
        queryText: this_.queryVO.queryText,
        nameKey:this_.queryVO.nameKey,
        type:this.all?'':'mansion',
        companyIdStr:this_.queryVO.companyId,
        orderColumn: this_.queryVO.sortField,
        orderValue: this_.queryVO.sortOrder
      }).then(res=>{
        this_.tableData = res.data.records
        this_.loading = false
        this_.pagination.current = this.pageInfo.current
        this_.pagination.total = res.data.total
        this_.toggleSelection()
      })
    },
    confirmSelect(){
      console.log("确认选择")
      this.$emit("confirmSelect",this.selectMansionList);
    }
  }
}
</script>
<style lang="less" scoped>
#selectMansion{
  padding:0 8px;
  height: 570px;
  .selectMansionDiv{
    display: flex;
    flex-direction: column;
    height: 110px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    .mansionLabel{
      font-size: 12px;
      color: #999999;
      letter-spacing: 0;
    }
    .mansionImgDiv{
      display: flex;
      flex-direction: row;
      margin-top: 15px;
      .contentDiv{
        display: flex;
        flex-direction: column;
        margin-right: 10px;
        .imgDiv{
          img{
            width: 70px;
            height: 40px
          }
        }
        .nameDiv{
          display: flex;
          flex-direction: row;
          .mansionName{
            width:80px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            display: block;
            color: #4D4D4D;
            font-size: 14px;
          }
          .deleteDiv{

          }
        }
      }
    }
  }
  .searchDiv{
    display: flex;
    flex-direction: column;
    .selectLetterDiv{
      display: flex;
      flex-direction: row;
      margin-top: 10px;
      .letterStyle{
        width: 25px;display: inline-block;text-align: center;color: #666;
      }
    }
  }
  .table-pagination{
    margin-top: 20px;
    text-align: right;
    padding-bottom: 20px;
  }
}
</style>
<style>
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color:#FABE00;
  border-color: #FABE00;
}
</style>